export default __webpack_public_path__ + "static/media/Distributed_servers.1449677e.png";